import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import './Contact.css';
import SubscribeFrom from 'react-mailchimp-subscribe';

const formProps = {
  action: 'https://zygouslabs.us17.list-manage.com/subscribe/post?u=7198e050a28cac79b536d0d07&amp;id=4cf907d94b',
  messages: {
    inputPlaceholder: "Enter email...",
    btnLabel: "Submit",
    sending: "Sending...",
    success: "Thanks! We'll keep you updated as we launch.",
    error: "Uh oh! An error occured."
  },
  styles: {
    sending: {
      fontSize: 18,
      color: "#8492A6"
    },
    success: {
      fontSize: 18,
      color: "#8EC9A9"
    },
    error: {
      fontSize: 18,
      color: "#EE6868"
    }
  }
}

class Contact extends Component {
  render() {
    return (
      <div id="contact">
        <div className="container">
          <div className="form">
            <h2>It's a little early.</h2>
            <p>Sign up now and we'll let you know when <br/>Zygous Labs is ready.<br/><br/></p>
            <SubscribeFrom {...formProps}/>            
          </div>
        </div>
        <div className="push"></div>
      </div>

    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/signup.js